import { PaymentRequestSettingFormType } from '@/context/services/notification_setting//type';
import { useUpdateReportNotificationSetting } from '@/context/services/notification_setting/notification_setting.service';
import { useTranslation } from '@/i18n';
import { useNotification } from '@moneyforward/ap-frontend-components';
import { useCallback, useState } from 'react';
export const useSubmit = (
  setError: (error: Error) => void,
  _onCallback: () => void | undefined
) => {
  const { t } = useTranslation();
  const notify = useNotification();
  const { mutateAsync } = useUpdateReportNotificationSetting();
  const [isLoading, setLoading] = useState(false);
  const onSubmit = useCallback(
    async (data: PaymentRequestSettingFormType) => {
      setLoading(true);
      try {
        const paymentRequestSetting = {
          data: {
            approvable_report: { is_active: data.approvableReport },
            workflow: workflowRequestValue(data.workflow),
            report_timeline: { is_active: data.reportTimeline },
            ...(data.reportViewer !== undefined && {
              report_viewer: { is_active: data.reportViewer },
            }),
          },
        };
        const { status, errors } = await mutateAsync(paymentRequestSetting);
        if (status === 'success') {
          if (_onCallback) {
            notify.success({
              title: t('update_notification_setting_success_message'),
              opts: {
                duration: 3000,
                style: {
                  position: 'fixed',
                },
              },
              bodyProps: {
                disabledSuffix: true,
              },
            });
            _onCallback();
          }
        } else {
          throw new Error(errors?.messages?.join('\n'));
        }
      } catch (error) {
        if (error instanceof Error) {
          setError(error);
        }
      } finally {
        setLoading(false);
      }
    },
    [_onCallback, setError, t, mutateAsync, notify]
  );
  return {
    onSubmit,
    isLoading,
  };
};

const workflowRequestValue = (
  workflow: 'every_step' | 'only_final_approval' | 'not_notify'
) => {
  if (workflow === 'only_final_approval')
    return { is_active: true, only_final_approval: true };
  if (workflow === 'every_step')
    return { is_active: true, only_final_approval: false };
  if (workflow === 'not_notify')
    return { is_active: false, only_final_approval: false };

  throw new Error();
};
